import { render } from "./viewMore.vue?vue&type=template&id=007fcba8&scoped=true"
import script from "./viewMore.vue?vue&type=script&lang=js"
export * from "./viewMore.vue?vue&type=script&lang=js"

import "./viewMore.vue?vue&type=style&index=0&id=007fcba8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-007fcba8"]])

export default __exports__